export const LRN_TYPE_LANDLINE = 0
export const LRN_TYPE_WIRELESS = 1
export const LRN_TYPE_VOIP = 2
export const LRN_TYPE_OTHER = 3
export const LRN_NOT_PERFORMED = 4